import { Fragment, memo } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const DropDownButton = function (props) {
    const { params, disabled } = props;

    return (
        <Menu as="div" className="relative inline-block text-left w-full">
            <div>
                <Menu.Button
                    disabled={disabled}
                    className={
                        !disabled
                            ? 'inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
                            : 'inline-flex w-full justify-center gap-x-1.5 rounded-md bg-slate-50 px-3 py-2 text-sm text-slate-300 shadow-sm ring-1 ring-inset ring-gray-300'
                    }
                >
                    {_t.orders.imports()}
                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items
                    portal={true}
                    modal={false}
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                >
                    <div className="py-1">
                        {!disabled &&
                            params?.map((item) => (
                                <Menu.Item key={item.id}>
                                    {({ active }) => (
                                        <a
                                            href={`/manage/itinerary/edit/${item.id}`}
                                            className={classNames(
                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                'block px-4 py-2 text-sm'
                                            )}
                                        >
                                            {item.itineraryName}
                                        </a>
                                    )}
                                </Menu.Item>
                            ))}
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
};

export default memo(DropDownButton, (prev, next) => {
    return prev.params.length === next.params.length;
});
